import { render, staticRenderFns } from "./oilfieldAI.vue?vue&type=template&id=8bfc10ce&scoped=true"
import script from "./oilfieldAI.vue?vue&type=script&lang=js"
export * from "./oilfieldAI.vue?vue&type=script&lang=js"
import style0 from "./oilfieldAI.vue?vue&type=style&index=0&id=8bfc10ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfc10ce",
  null
  
)

export default component.exports